import React from 'react';
import Link from '@material-ui/core/Link';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from 'react-hook-form';
import FormTextField from 'Components/FormTextField';
import ModalContent from '../ModalContent';
import * as Regex from '../../regex';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

const styles = (theme) => ({
  twoFieldContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftFormField: {
    marginRight: '20px',
  },
});

function SignUp({ registerWithFirebase, setActiveModal, classes }) {
  const { register, handleSubmit, watch, errors } = useForm({
    defaultValues: {},
  });

  const handleLoginModalOpen = () => {
    setActiveModal('login');
  };

  const tosWindow = () => {
    window.open(
      `${window.location.origin}/TOS?hasNav=false`,
      'tos',
      'width=500,height=800',
    );
  };

  const onSubmit = async (data) => {
    const { firstName, lastName, email, password } = data;

    try {
      const regRes = await registerWithFirebase({
        firstName,
        lastName,
        email,
        password,
      });
      if (regRes.type === 'REGISTER_ERROR') {
        alert(regRes.payload.message);
      }
      return;
    } catch (err) {
      console.warn('Registration server error: ', err);
      alert(err);
      return;
    }
  };

  return (
    <ModalContent
      title="Sign Up"
      buttonText="Sign Up"
      containerMaxWidth="sm"
      onFormSubmit={handleSubmit(onSubmit)}
      formContents={
        <>
          <div className={classes.twoFieldContainer}>
            <FormTextField
              fullWidth
              label="First Name"
              name="firstName"
              margin="normal"
              required
              error={!!errors.firstName}
              helperText={errors.firstName && errors.firstName.message}
              inputRef={register({
                required: 'Provide a first name',
                minLength: {
                  value: 1,
                  message: 'Name too short',
                },
              })}
              placeholder="First Name"
              className={classes.leftFormField}
            />
            <FormTextField
              fullWidth
              label="Last Name"
              name="lastName"
              margin="normal"
              required
              error={!!errors.lastName}
              helperText={errors.lastName && errors.lastName.message}
              inputRef={register({
                required: 'Provide a last name',
                minLength: {
                  value: 2,
                  message: 'Last name too short',
                },
              })}
              placeholder="Last Name"
            />
          </div>
          <FormTextField
            fullWidth
            label="Email"
            name="email"
            margin="normal"
            required
            error={!!errors.email}
            helperText={errors.email && errors.email.message}
            inputRef={register({
              required: 'Provide your login email',
              pattern: {
                value: Regex.email,
                message: 'Provide a valid email address',
              },
            })}
            placeholder="Enter Email"
          />
          <div className={classes.twoFieldContainer}>
            <FormTextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              required
              error={!!errors.password}
              helperText={errors.password && errors.password.message}
              inputRef={register({
                required: 'Provide the password',
                minLength: {
                  value: 5,
                  message: 'Password too short',
                },
              })}
              className={classes.leftFormField}
            />
            <FormTextField
              fullWidth
              label="Repeat Password"
              name="rePassword"
              type="password"
              required
              error={!!errors.rePassword}
              helperText={errors.rePassword && "Passwords don't match"}
              inputRef={register({
                required: 'Repeat password',
                validate: (value) => value === watch('password'),
              })}
            />
          </div>
          <div className={classes.twoFieldContainer}>
            <FormControl
              control={
                <Checkbox
                  name="tosCheckbox"
                  className={classes.productCheckbox}
                  inputRef={register({
                    required: 'Please agree to the terms of service',
                  })}
                  required={true}
                />
              }
              label={
                <p>
                  I have read and agree to the{' '}
                  <Link onClick={tosWindow} target={'tos'}>
                    terms of service
                  </Link>
                  .
                </p>
              }
              color="primary"
            >
              {errors.tosCheckbox && (
                <FormHelperText>
                  'Please agree to the terms of service'
                </FormHelperText>
              )}
            </FormControl>
          </div>
        </>
      }
      footerContents={
        <Link component="button" variant="body2" onClick={handleLoginModalOpen}>
          Already have an account? Sign in
        </Link>
      }
    />
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      registerWithFirebase: actions.registerWithFirebase,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(
  connect(null, mapDispatchToProps)(withStyles(styles)(SignUp)),
);
